import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/useT';
import { aboutUs as auEn } from '../i18n/translations/en';
import { aboutUs as auEs } from '../i18n/translations/es';
import { boardMembers, director } from '../data/boardMembers';
import './AboutUs.css';

const newsItems = [
    { date: "March 28, 2026", title: "Easter at the Park!", type: "Events" },
    { date: "March 2026", title: "New Drugstore Opened Now!", type: "News" },
];

const AboutUs = () => {
    const t = useT({ en: auEn, es: auEs });
    const [openEdc, setOpenEdc] = useState(null);
    const toggleEdc = (id) => setOpenEdc(prev => prev === id ? null : id);

    return (
        <section className="section" id="about-us">
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">{t.title}<span>{t.titleSpan}</span></h2>
                </div>

                <div className="au-block" id="what-we-do">
                    <div className="au-whatwedo-grid">
                        <div>
                            <h3 className="au-block-title">{t.whatWeDo.title}</h3>
                            <p className="au-mission">{t.whatWeDo.body}</p>
                        </div>
                        <div>
                            <h3 className="au-block-title">{t.missionStatement.title}</h3>
                            <blockquote className="au-mission-statement">{t.missionStatement.body}</blockquote>
                        </div>
                    </div>
                </div>
                <hr className="au-divider" />

                <div className="au-block" id="what-is-edc">
                    <h3 className="au-block-title">{t.whatIsEdc.title}</h3>
                    <p className="au-edc-intro">{t.whatIsEdc.intro}</p>
                    <div className="au-accordion">
                        {t.whatIsEdc.sections.map(sec => {
                            const isOpen = openEdc === sec.id;
                            return (
                                <div key={sec.id} className={`au-acc-panel${isOpen ? ' au-acc-panel--open' : ''}`}>
                                    <button className="au-acc-trigger" onClick={() => toggleEdc(sec.id)}>
                                        <span>{sec.title}</span>
                                        <span className={`au-acc-caret${isOpen ? ' au-acc-caret--open' : ''}`}>▼</span>
                                    </button>
                                    {isOpen && (
                                        <div className="au-acc-content">
                                            {sec.body && <p className="au-acc-body">{sec.body}</p>}
                                            {sec.list && (
                                                <ul className="au-acc-list">
                                                    {sec.list.map((item, i) => <li key={i}>{item}</li>)}
                                                </ul>
                                            )}
                                            {sec.subsections && sec.subsections.map((sub, i) => (
                                                <div key={i} className="au-acc-subsection">
                                                    <h5 className="au-acc-subname">{sub.name}</h5>
                                                    {sub.content && <p className="au-acc-subcontent">{sub.content}</p>}
                                                    {sub.list && (
                                                        <ul className="au-acc-list">
                                                            {sub.list.map((item, j) => <li key={j}>{item}</li>)}
                                                        </ul>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <hr className="au-divider" />

                <div className="au-block" id="staff">
                    <h3 className="au-block-title">{t.staff.title}</h3>
                    <Link to={`/profile/${director.id}`} className="au-director-featured">
                        <div className="au-director-featured-photo-wrap">
                            <img src={director.photo} alt={director.name} className="au-director-featured-photo" />
                        </div>
                        <div className="au-director-featured-body">
                            <span className="au-director-badge">{t.directorBadge}</span>
                            <h3 className="au-director-featured-name">{director.name}</h3>
                            <p className="au-director-featured-org">{t.directorOrg}</p>
                            <p className="au-director-featured-bio">{director.bio}</p>
                            <span className="au-director-featured-cta">{t.directorCta}</span>
                        </div>
                    </Link>
                </div>
                <hr className="au-divider" />

                <div className="au-block" id="board">
                    <h3 className="au-block-title">{t.board.title}</h3>
                    <div className="au-board-grid">
                        {boardMembers.map((m) => (
                            <Link key={m.id} to={`/profile/${m.id}`} className="au-board-card">
                                <img src={m.photo} alt={m.name} className="au-board-photo" />
                                <div className="au-board-info">
                                    <span className="au-board-place">{m.place}</span>
                                    <span className="au-board-name">{m.name}</span>
                                    <span className="au-board-role">{m.role}</span>
                                    <span className="au-view-profile">{t.viewProfile}</span>
                                </div>
                            </Link>
                        ))}
                        <div className="au-board-card au-vacant">
                            <div className="au-board-photo au-board-photo-vacant">?</div>
                            <div className="au-board-info">
                                <span className="au-board-place">Place 5</span>
                                <span className="au-board-name">{t.vacantName}</span>
                                <span className="au-board-role">{t.vacantRole}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="au-divider" />

                <div className="au-block" id="meetings">
                    <h3 className="au-block-title">{t.meetings.title}</h3>
                    <p>{t.meetings.body}</p>
                    <a href="https://www.cityofvenus.org/minutes-and-agendas" target="_blank" rel="noreferrer" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
                        {t.meetings.cta}
                    </a>
                </div>
                <hr className="au-divider" />

                <div className="au-block" id="news">
                    <h3 className="au-block-title">{t.news.title}</h3>
                    <div className="au-news-list">
                        {newsItems.map((n, i) => (
                            <div key={i} className="au-news-item">
                                <span className="au-news-type">{n.type}</span>
                                <span className="au-news-date">{n.date}</span>
                                <h4 className="au-news-title">{n.title}</h4>
                            </div>
                        ))}
                    </div>
                </div>
                <hr className="au-divider" />

                <div className="au-block" id="contact">
                    <h3 className="au-block-title">{t.contact.title}</h3>
                    <div className="au-contact-grid">
                        <div className="au-contact-info">
                            <p><strong>{t.contact.addressLabel}</strong><br />700 W US Highway 67<br />Venus, Texas 76084</p>
                            <p><strong>{t.contact.phoneLabel}</strong><br />(972) 366-3348 ext. 206</p>
                        </div>
                        <div className="au-contact-cta">
                            <p>{t.contact.readyText}</p>
                            <button className="btn btn-primary" style={{ marginTop: '1rem' }}>{t.contact.sendMessage}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
